import React from 'react';

function LegendOverview(props) {
  const textColor = !props.dark ? '-light' : '';

  return (
    <div className="c-legend-overview">
      {props.data.map((item, index) => (
        <p key={index} className={`legend-item -text ${textColor} -legend -color${item.country || ''} -${props.theme}`}>{item.value}</p>
      ))}
    </div>
  );
}

LegendOverview.propTypes = {
  data: React.PropTypes.array.isRequired,
  theme: React.PropTypes.string,
  dark: React.PropTypes.bool
};

export default LegendOverview;



// WEBPACK FOOTER //
// ./app/components/common/Legend.jsx